import accountReducer from './accountReducer';
import notificationReducer from './notificationReducer';
const rootReducer = {
    account: accountReducer,
    alert: notificationReducer
};

export default rootReducer;